import checkLoginMixin from '@/mixins/checkLoginMixin'
import productPlaceComponentMixin from '@/mixins/productPlaceComponentMixin'
import productUtils from '@/core/productUtils'
import envCodes from '@/assets/js/envCodes'
import {
  NavigateToBrowser,
  GetProjectInfo,
  LoadPublicComponent,
  // PlacePublicComponent,
  RecordJournal,
  SetEquipmentSelectionResult,
} from '@/core/gcsUtils'
import { mapGetters, mapMutations } from 'vuex'
import Utils from '@/core/utils'

export default {
  mixins: [checkLoginMixin, productPlaceComponentMixin],
  data() {
    return {
      selecting: false,
      saveAsPath: '',
      defaultDesignProps: [] // 基础选型的设计缺省值
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      project: 'selectionList/project',
      shareDefinitions: 'shareParams/shareDefinitions'
    }),
    speedType() {
      const parameters = this.$store.state.productDetail.parameters
      const categoryCode = this.detail.gjwCategoryCode
      return productUtils.getSpeedType(categoryCode, parameters)
    },
    fluidCode() {
      return envCodes?.fluid
    },
    // 水泵的详情关注路由上流量的单位
    getIsFluidMeterUnit() {
      const fluidProps = this.selectedProductDesignProperties.find((p) => p.codes === this.fluidCode)
      return this.category === 'pump' && fluidProps?.unit === 'L/s'
    },
    displayDesignValues() {
      return this.selectedProductDesignProperties.reduce((acc, p) => {
        let values
        const isDoubleSpeed = p.codes.includes('/')
        if (isDoubleSpeed) {
          if (p.values) {
            values = p.values.split('/').map((s) => s === '' ? '-' : s).join('/')
          } else {
            values = '-/-'
          }
        } else {
          values = this.$fmtValue(p.values, '-')
        }
        acc.push({
          ...p,
          values
        })
        return acc
      }, [])
    }
  },
  methods: {
    ...mapMutations({
      setShopAnimation: 'setShowShopAnimation'
    }),
    detailToFeedback() {
      const url = this.detail.brandUrl || encodeURI(`${process.env.VUE_APP_GJW_PORTAL_URL}/feedback?title=${this.detail.brandName}&from=4&source=Selection`)
      if (this.platform === 'r') {
        this.$revitClient.NavigateToBrowser(url)
      } else if (this.platform === 'g') {
        NavigateToBrowser(url)
      } else if (this.platform === 'cs') {
        this.$desktopClient.NavigateToBrowser(url)
      } else {
        window.open(url, '_blank')
      }
    },

    // 缺省的设计点值整理
    getDesignProperties() {
      if (this.category === 'fan') {
        const speedType = this.speedType
        const isDoubleSpeed = speedType === 'DOUBLE_SPEED'
        return [
          {
            codes: isDoubleSpeed ? `${envCodes.windHigh}/${envCodes.windLow}` : envCodes.wind,
            name: '设计风量',
            sort: 1,
            unit: 'm³/h',
            values: null,
            type: 'design'
          }, {
            codes: isDoubleSpeed ? `${envCodes.pressureHigh}/${envCodes.pressureLow}` : envCodes.pressure,
            name: '设计全压',
            sort: 2,
            unit: 'Pa',
            values: null,
            type: 'design'
          }
        ]
      } else if (this.category === 'pump') {
        return [
          {
            codes: this.fluidCode,
            name: '设计流量',
            sort: 1,
            unit: 'm³/h',
            values: null,
            type: 'design'
          }, {
            codes: envCodes.head,
            name: '设计扬程',
            sort: 2,
            unit: 'm',
            values: null,
            type: 'design'
          },
        ]
      } else {
        // 基础选型产品的缺省设计值处理：1、找到性能属性 2、从产品属性值中找到对应属性值（额定）
        return this.defaultDesignProps
      }
    },
    handleDefaultDesignProps(code) {
      this.$api.classification.getClassificationProperties(code).then((data) => {
        const ret = []
        if (data) {
          // 过滤性能筛选属性
          const designProperties = productUtils.getAllPropertiesByCode(data, 'isPerformanceFilter', (value) => !!value)
          const productParameters = this.$store.state.productDetail.parameters
          designProperties.forEach((d, i) => {
            let values = null
            const p = productParameters.find((c) => c.code === d.code)
            if (p && p.type === 'Number') {
              values = p.value1
            }
            ret.push({
              codes: p.code,
              name: `设计${p.name}`,
              sort: i,
              unit: p.unitSymbol,
              values: values,
              type: 'design'
            })
          })
        }
        this.defaultDesignProps = ret
      })
    },

    // 详情页选中产品,处理设计值&运行值
    async getSelectedProductParams(productId) {
      try {
        const condition = []
        const isFluidMeterUnit = this.isFluidMeterUnit
        // 检索设计属性
        this.selectedProductDesignProperties.map((s) => {
          if (s.codes.includes('/')) {
            const codes = s.codes.split('/')
            const values = s.values ? s.values.split('/') : [null, null]
            condition.push(
              {
                code: codes[0],
                value: values[0]
              },
              {
                code: codes[1],
                value: values[1]
              },
            )
          } else {
            isFluidMeterUnit
              ? condition.push({ code: s.codes, value: s.codes === this.fluidCode ? Utils.timesValue(s.values, 3.6, 2) : s.values })
              : condition.push({ code: s.codes, value: s.values })
          }
        })
        const category = this.category
        const isFanOrPump = this.isFanOrPump
        const hasDesignProperties = this.searchedWithCurveData
        // 是否有调速属性检索
        const hasRegulatedSpeed = Boolean(this.$refs.curveChart && this.$refs.curveChart.speedRegulated)
        let runtimeProperties, designProperties
        // 只有水泵、风机有运行属性，基础选型无运行属性
        if (isFanOrPump) {
          // 水泵有搜索有调速的运行值：从工况曲线返回的数据获取
          if (category === 'pump' && hasDesignProperties && hasRegulatedSpeed) {
            let intersectionPoints = this.originWorkCondition.speedRegulate.intersectionPoints
            if (isFluidMeterUnit) {
              intersectionPoints = intersectionPoints.length && intersectionPoints.reduce((acc, ip) => {
                acc.push({
                  ...ip,
                  valueX: ip.valueXDefault,
                  unitX: 'm³/h'
                })
                return acc
              }, [])
            }
            runtimeProperties = this.handlePumpRegulatedRuntimeData(intersectionPoints)
          } else {
            // 风机有无搜索的运行值：都能从获取产品运行数据的接口获取
            // 水泵有搜索无调速和无搜索的运行值：从获取产品运行数据的接口获取
            const res = await this.$api.products.getRuntimeData(productId, { condition })
            runtimeProperties = this.handleProductRuntimePropertiesData(res || [], category, this.speedType)
          }
        }
        // 风机水泵如果没有设计属性为从路由上确定
        if (isFluidMeterUnit) {
          designProperties = this.selectedProductDesignProperties.reduce((acc, s) => {
            if (s.codes === this.fluidCode) {
              acc.push({
                ...s,
                unit: 'm³/h',
                values: this.$fmtValue(Utils.timesValue(s.values, 3.6, 2), '-')
              })
            } else {
              acc.push({
                ...s,
                values: this.$fmtValue(s.values, '-')
              })
            }
            return acc
          }, [])
        } else {
          designProperties = this.displayDesignValues
        }
        return { productId, designProperties, runtimeProperties }
      } catch (error) {
        console.log(error)
        return { productId, designProperties: [], runtimeProperties: [] }
      }
    },

    // 选中产品
    async toSelected(productId) {
      try {
        this.selecting = true
        this.setShopAnimation(false)
        const res = await this.checkLogin()
        if (res) {
          const selectedProduct = await this.getSelectedProductParams(productId)
          await this.handleSelectProduct(selectedProduct)
          this.selectTrack({
            productId,
            gjwCategoryCode: this.detail.gjwCategoryCode,
            gjwCategoryName: this.detail.gjwCategoryName,
            source: 'detail'
          })
          this.$nextTick(() => {
            this.setShopAnimation(true)
          })
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.selecting = false
      }
    },
    // 选中产品
    async handleSelectProduct(payload) {
      try {
        await this.$api.project.selectProduct(this.project.id, payload)
        this.$message.success('已选中，可在“已选产品”中查看')
      } catch (err) {
        this.$message.error('选中失败，请稍后重试')
        console.error(err)
      }
    },
    // 选中产品埋点
    selectTrack(payload) {
      this.$tracks({
        event: 'productSelect',
        params: {
          g_c_product_id: payload.productId,
          g_c_class_code: payload.gjwCategoryCode,
          g_c_class_name: payload.gjwCategoryName,
          g_c_selection_project_id: this.project.id,
          g_c_source: payload.source,
        }
      })
    },
    // 插件端获取项目信息
    async getProjectInfo() {
      let projectInfo = {}
      if (this.platform === 'g') {
        const { data } = await GetProjectInfo()
        projectInfo = data || {}
      } else if (this.platform === 'r') {
        const { data } = await this.$revitClient.GetProjectInfo()
        projectInfo = data || {}
      }
      return projectInfo
    },
    /** 以下是不同端的查看、载入和布置方法 */
    async viewRevitComp(comp) {
      this.$refs.componentDetail && this.$refs.componentDetail.open(comp, 'r')
      const projectInfo = await this.getProjectInfo()
      this.$tracks({
        event: 'visitShopComponentDetail',
        params: {
          id: comp.id,
          productId: this.productId,
          source: 'selection',
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        }
      })
    },
    async viewGcsComp(comp) {
      this.$refs.componentDetail && this.$refs.componentDetail.open(comp, 'g')
      const projectInfo = await this.getProjectInfo()
      this.$tracks({
        event: 'visitShopComponentDetail',
        params: {
          g_c_component_id: comp.id,
          g_c_component_name: comp.name,
          g_c_product_id: this.productId,
          g_c_source: 'selection',
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        }
      })
    },
    viewCsComp(comp) {
      this.$refs.componentDetail && this.$refs.componentDetail.open(comp, 'cs')
      this.$tracks({
        event: 'visitShopComponentDetail',
        params: {
          g_c_component_id: comp.id,
          g_c_component_name: comp.name,
          g_c_product_id: this.productId,
          g_c_source: 'selection'
        }
      })
    },
    viewWebComp(comp) {
      // 跳转到门户
      let url
      const { platformCode, softwareCode, id, softwareVersions, componentFamilyTypeName } = comp
      if (platformCode === 'NOVA_DESIGN' && softwareVersions && softwareVersions.length) {
        const len = softwareVersions.length
        const softwareVersion = softwareVersions[len - 1] || {}
        url = `${process.env.VUE_APP_GJW_PORTAL_URL}/detail/${id}?platformCode=${platformCode}&softwareCode=${softwareCode}&softwareVersion=${softwareVersion.version}&familyTypeName=${encodeURIComponent(componentFamilyTypeName)}&locationName=Selection&productId=${this.productId}`
      } else {
        url = `${process.env.VUE_APP_GJW_PORTAL_URL}/detail/${id}?platformCode=${platformCode}&softwareCode=${softwareCode}&locationName=Selection&productId=${this.productId}`
      }
      window.open(url, '_blank')
    },

    /**
     * G 操作抽提出公共步骤 ：
     * 载入和布置都要判断是否已登录
     * @param {*} operation 操作类型
     * @param {*} comp 操作构件
     * @param {*} confirmFunc 确认操作方法
     */
    async operationCommon(operation, comp, confirmFunc) {
      try {
        const login = await this.checkLogin()
        if (login) {
          confirmFunc(comp)
        }
      } catch (error) {
        this.$message.error(`${operation}失败`)
      }
    },
    // G 载入构件
    async loadGcsComp(comp) {
      await this.operationCommon('载入', comp, this.confirmLoadGcs)
    },
    // G 资源列表页载入构件
    async toLoadGcsComp(comp) {
      if (!comp.resource) {
        comp.resource = await this.handleResource(comp.id)
      }
      if (!comp.resource || comp.resource.length === 0) {
        this.$fullLoading.close()
        this.$confirm('暂无可用资源，我们将联系厂商尽快提供，请通过“反馈”或“广小二”联系官方客服。', '载入失败', {
          type: 'warning',
          showCancelButton: false,
        }).then().catch()
      } else {
        const compFirst = comp.resource[0]
        await this.operationCommon('载入', compFirst, this.confirmLoadGcs)
      }
    },
    // G 选中构件
    async selectGcsComp(comp) {
      await this.$api.project.selectProductGcs(comp.id).then((res) => {
        console.log('选中构件传给机电-------', res)
        SetEquipmentSelectionResult(res)
      }).catch(() => {
      })
    },
    /**
     * G 确认载入
     * 1.获取载入的构件信息 2.插件端载入
     * @param {*} comp
     */
    async confirmLoadGcs(comp) {
      try {
        this.$fullLoading.open(this.$t('load.loading'))
        const params = {
          id: String(comp.id),
          digitalComponentId: String(comp.coreResourceVersionId),
          name: comp.name,
          suffix: comp.suffix,
          categoryNames: comp.softwareCategoryNames ? comp.softwareCategoryNames.split('_') : [],
          thumbnail: comp.thumbnail
        }
        RecordJournal('LoadPublicComponentFromProducts', params)
        const { data: isSuccess } = await LoadPublicComponent(params)
        isSuccess && this.$message.success('载入成功，请前往对应安装产品界面进行布置')
        !isSuccess && this.$message.error('载入失败')
        const { data } = await GetProjectInfo()
        this.$tracks({
          event: 'shopComponentLoad',
          params: {
            g_c_component_id: comp.id,
            g_c_product_id: this.productId,
            g_c_source: 'selection',
            g_c_project_id: data && data.id,
            g_c_project_file_path: data && data.path,
            g_c_project_file_name: data && data.name
          }
        })
      } catch (error) {
        this.$message.error('载入失败')
      } finally {
        this.$fullLoading.close()
      }
    },
    // async replayLoadPublicComponent(args) {
    //   const { code } = await LoadPublicComponent(args)
    //   return code === 'success' ? { code: 'success', data: true } : { code: 'failure', message: 'actionName:LoadPublicComponent Failed', data: false }
    // },
    // // 匹配构件规格
    // async getGcsFamilyTypeName(componentId) {
    //   try {
    //     const { familyTypes } = await this.$api.gcsComponent.detail(this.softwareCode, componentId, this.softwareVersion)
    //     if (familyTypes && familyTypes.length && this.detail.model) {
    //       const familyType = familyTypes.find((f) => f.name === this.detail.model)
    //       return familyType ? familyType.name : familyTypes[0].name
    //     }
    //     return null
    //   } catch (error) {
    //     return null
    //   }
    // },
    // G 布置构件
    async placeGcsComp(comp) {
      await this.operationCommon('布置', comp, this.confirmPlaceGcs)
    },
    /**
     * G 确认布置
     * 1.获取公共构件规格2.添加到项目库得到项目构件信息
     * @param {*} comp
     */
    async confirmPlaceGcs(comp) {
      this.$fullLoading.open()
      try {
        const { productId, designProperties, runtimeProperties } = await this.getSelectedProductParams(this.productId)
        const payload = {
          productId,
          publicComponentId: comp.id,
          digitalComponentId: comp.coreResourceVersionId,
          equipmentNum: null,
          powerConsumptionPerAirVolume: this.powerConsumptionPerAirVolume || null,
          designProperties,
          runtimeProperties,
        }
        const trackPartParams = {
          g_c_product_id: this.productId,
          g_c_source: 'product_detail',
        }
        await this.placeGcsComponent({ payload, trackPartParams, recordMethodName: 'PlacePublicComponentFromProducts' })
      } catch (error) {
        this.$message.error('布置失败')
      } finally {
        this.$fullLoading.close()
      }
    },
    // // 回放布置
    // async replayPlacePublicComponent(args) {
    //   const { publicComponent: params, familyTypeToBePlaced: familyType } = args
    //   const { code } = await PlacePublicComponent(params, familyType)
    //   return code === 'success' ? { code: 'success', data: true } : { code: 'failure', message: 'actionName:PlacePublicComponent Failed', data: false }
    // },

    // R-布置构件
    async placeRevitComp(comp) {
      const isLog = await this.checkLogin()
      if (!isLog) { return }
      try {
        this.$fullLoading.open()
        // 获取产品布置所需要的信息
        const payload = {
          productId: this.productId,
          publicComponentId: comp.id,
          softwareCode: this.softwareCode,
          softwareVersion: this.softwareVersion,
        }
        const rPayload = {
          payload,
          designValue: this.selectedProductDesignProperties,
          trackPartParams: {
            g_c_product_id: this.productId,
            g_c_source: 'product_detail',
          },
        }
        await this.placeRevitComponent(rPayload)
      } catch (error) {
        this.$message.error('布置失败')
      } finally {
        this.$fullLoading.close()
      }
    },

    /**
   *  根据已有的运行数据(接口返回了运行属性的额定值)对应得到设计值数据（对应属性额定值）
   * @param data: 运行点数据
   * @param category: 品类（fan/pump/...）
   * return 设计参数
   * */

    handleProductOriginDesignData(data, category) {
      data = data || []
      let designKeys = []
      switch (category) {
        case 'fan': designKeys = [{ name: '设计风量', runtimeName: '运行风量' }, { name: '设计全压', runtimeName: '运行全压' }]; break
        case 'pump': designKeys = [{ name: '设计流量', runtimeName: '运行流量' }, { name: '设计扬程', runtimeName: '运行扬程' }]; break
      }
      return designKeys.reduce((acc, dk, index) => {
        const designData = data.find((d) => d.name === dk.runtimeName)
        if (designData) {
          acc.push({
            codes: designData.codes,
            name: dk.name,
            type: 'design',
            sort: index + 1,
            unit: designData.unit,
            values: this.$fmtValue(designData.values, '-')
          })
        }
        return acc
      }, [])
    },

    /**
   * 根据接口返回的产品运行点数据、固定的code组成运行参数数组
   * @param data: 需要处理的原始数据，数组
   * @param category: 品类（fan/pump/...）
   * @param speed: 当品类为风机时，需要区分单双速（SINGLE_SPEED/DOUBLE_SPEED）
   * @return 返回值为处理好运行点的数组
   */
    handleProductRuntimePropertiesData(data, category, speed) {
      data = data || []
      const pumpRuntimeKeys = [
        { fName: 'speed', name: '运行转速' },
        { fName: 'fluid', name: '运行流量' },
        { fName: 'head', name: '运行扬程' },
        { fName: 'efficiency', name: '运行效率' }
      ]
      const fanRuntimeKeys = [
        { fName: 'wind', name: '运行风量' },
        { fName: 'pressure', name: '运行全压' },
        { fName: 'efficiency', name: '运行全压效率' },
      ]
      let runtimeKeys = []
      switch (category) {
        case 'fan': runtimeKeys = fanRuntimeKeys; break
        case 'pump': runtimeKeys = pumpRuntimeKeys; break
      }
      // attention：this.$handleDoubleSpeedData中this需要指向全局的vue实例
      return runtimeKeys.reduce((acc, key, index) => {
      // 双速处理成用 '/' 拼接而成的数据
        if (speed === 'DOUBLE_SPEED') {
          const code1 = envCodes[`${key.fName}High`]
          const runtimeData1 = data.find((d) => d.code === code1)
          const code2 = envCodes[`${key.fName}Low`]
          const runtimeData2 = data.find((d) => d.code === code2)
          const item = {
            codes: `${code1}/${code2}`,
            name: key.name,
            type: 'runtime',
            sort: index + 1,
            unit: runtimeData1?.unit,
            values: this.$handleDoubleSpeedData(this.$fmtValue(runtimeData1?.value, '-'), this.$fmtValue(runtimeData2?.value, '-'))
          }
          acc.push(item)
        } else {
          const code = envCodes[key.fName]
          const runtimeData = data.find((d) => d.code === code)
          if (runtimeData) {
            const { unit, displayType, ratedValue, value } = runtimeData
            const values = displayType === 'Range' ? this.$fmtValue(ratedValue, '-') : this.$fmtValue(value, '-')
            const item = {
              codes: code,
              name: key.name,
              type: 'runtime',
              sort: index + 1,
              unit: unit,
              values
            }
            acc.push(item)
          }
        }
        return acc
      }, [])
    },

    /**
   *  水泵(调速后)需要根据默认调速比例的运行数据得到运行参数
   * @param data: 默认调速比例的运行数据
   * return 运行参数
   * */
    handlePumpRegulatedRuntimeData(data = []) {
      const runtimekeys = [
        { name: '转速', code: 'speed', rName: '运行转速' },
        { name: '流量', code: 'fluid', rName: '运行流量' },
        { name: '扬程', code: 'head', rName: '运行扬程' },
        { name: '效率', code: 'efficiency', rName: '运行效率' }
      ]
      return runtimekeys.reduce((acc, rk, index) => {
        const item = {
          codes: envCodes[rk.code],
          name: rk.rName,
          type: 'runtime',
          sort: index + 1,
        }
        if (index === 0) {
        // 转速处理
          const xAxis = data[0]
          item.unit = xAxis.unitSpeed
          item.values = this.$fmtValue(xAxis.speed, '-')
        } else if (index === 1) {
        // 流量处理
          const xAxis = data[0]
          item.unit = xAxis.unitX
          item.values = this.$fmtValue(xAxis.valueX, '-')
        } else {
          const yAxis = data.find((d) => d.nameY === rk.name)
          if (yAxis) {
            item.unit = yAxis.unitY
            item.values = this.$fmtValue(yAxis.valueY, '-')
          }
        }
        acc.push(item)
        return acc
      }, [])
    },
    // CS 布置构件
    async placeCSComp(comp) {
      try {
        this.$fullLoading.open(this.$t('load.downloading'))
        await this.placeCSComponent(comp)
      } finally {
        this.$fullLoading.close()
      }
    },
  },
}
